import { render, staticRenderFns } from "./CambiarDatos.vue?vue&type=template&id=b378e7c6"
import script from "./CambiarDatos.vue?vue&type=script&lang=js"
export * from "./CambiarDatos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports